import { v4 as uuid } from 'uuid';
import { encounterIdA } from '../encounters';
import { Order, OrderType } from '@getvim-os/types';

export const orderF: Order = {
  id: uuid(),
  type: OrderType.LAB,
  icd: [],
  cpts: [
    {
      name: 'Tenodesis long tendon biceps',
      code: '23430',
    },
  ],
  encounterId: encounterIdA,
  createdDate: '2000-01-01',
};
